var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5831_27918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5714 8.60756V7.10756C18.5714 5.53613 17.2857 4.28613 15.75 4.28613H4.25C2.71429 4.28613 1.42857 5.57185 1.42857 7.10756V8.60756C0.607143 8.78613 0 9.50042 0 10.3576V13.929C0 14.1433 0.142857 14.2861 0.357143 14.2861H0.714286V15.3576C0.714286 15.5718 0.857143 15.7147 1.07143 15.7147C1.28571 15.7147 1.42857 15.5718 1.42857 15.3576V14.2861H18.5714V15.3576C18.5714 15.5718 18.7143 15.7147 18.9286 15.7147C19.1429 15.7147 19.2857 15.5718 19.2857 15.3576V14.2861H19.6429C19.8571 14.2861 20 14.1433 20 13.929V10.3576C20 9.50042 19.3929 8.78613 18.5714 8.60756ZM2.14286 7.10756C2.14286 5.92899 3.10714 5.00042 4.25 5.00042H15.7143C16.8929 5.00042 17.8214 5.9647 17.8214 7.10756V8.57185H16.3571C16.25 7.75042 15.5357 7.14328 14.7143 7.14328H13.0714C12.25 7.14328 11.5357 7.75042 11.4286 8.57185H8.53571C8.42857 7.75042 7.71429 7.14328 6.89286 7.14328H5.25C4.42857 7.14328 3.71429 7.75042 3.60714 8.57185H2.14286V7.10756ZM15.6786 8.57185H12.1786C12.2857 8.14328 12.6786 7.85756 13.1071 7.85756H14.75C15.1786 7.85756 15.5714 8.14328 15.6786 8.57185ZM7.82143 8.57185H4.32143C4.42857 8.14328 4.82143 7.85756 5.25 7.85756H6.89286C7.32143 7.85756 7.71429 8.14328 7.82143 8.57185ZM19.2857 13.5718H0.714286V10.3576C0.714286 9.75042 1.17857 9.28613 1.78571 9.28613H18.2143C18.8214 9.28613 19.2857 9.75042 19.2857 10.3576V13.5718Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5831_27918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRooms);
export default __webpack_public_path__ + "static/media/rooms.3320bea72e4babee6cd45004f02f6793.svg";
export { ForwardRef as ReactComponent };